import PropTypes from 'prop-types';

const NavigationControllerPropType = {
  redirect: PropTypes.bool,
  goToURL: PropTypes.string,
};

export default NavigationControllerPropType;
